(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wanedc-field-manuals"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SELECTOR = '[data-fm-root]';
    const FINE_POINTER = '(hover: hover) and (pointer: fine)';

    const REDUCED_MQ = window.matchMedia('(prefers-reduced-motion: reduce)');
    let reducedMotionOn = REDUCED_MQ.matches;
    const onReducedChange = () => {
      reducedMotionOn = REDUCED_MQ.matches;
    };
    if (REDUCED_MQ.addEventListener) REDUCED_MQ.addEventListener('change', onReducedChange);
    else if (REDUCED_MQ.addListener) REDUCED_MQ.addListener(onReducedChange);

    function reducedMotion() {
      return reducedMotionOn;
    }

    function setupRoot(root) {
      if (root.dataset.fmInit === '1') return;
      root.dataset.fmInit = '1';

      const cards = Array.from(root.querySelectorAll('[data-fm-book]'));
      const panel = root.querySelector('.fm-detail');
      const inspectCta = root.querySelector('[data-fm-inspect-cta]');
      const NARROW_MQ = window.matchMedia('(max-width: 749px)');
      const FINE_MQ = window.matchMedia('(hover: hover) and (pointer: fine)');
      // 窄屏且非精确指针（手机/触屏）才走两步标注视图；桌面窄窗口不受影响
      const useInspectView = () => NARROW_MQ.matches && !FINE_MQ.matches;
      let inspectCard = null;
      const backBtn = root.querySelector('[data-fm-detail-back]');
      const addBtn = root.querySelector('[data-fm-add-to-cart]');
      if (addBtn) {
        const lbl = addBtn.querySelector('.fm-add-to-cart__label');
        addBtn.dataset.defaultLabel = lbl ? lbl.textContent : '';
      }
      const soldOutLabel = root.dataset.fmSoldoutLabel || 'Sold out';
      const addedLabel = root.dataset.fmAddedLabel || 'Added to cart';
      const addErrorLabel = root.dataset.fmErrorLabel || 'Error adding to cart';
      const parallaxOn = root.dataset.fmParallax !== 'false';
      let raf = null;
      let deckActive = false;
      let pointerX = 0;
      let pointerY = 0;
      let parallaxActive = false;
      let parallaxIdleTimer = null;
      let inView = false;
      let observer = null;
      let unstackTimer = null;
      let settling = false;
      let settleTimer = null;
      const STACK_TOLERANCE = 40;

      function fillPanel(card) {
        if (!panel) return;
        const set = (sel, value) => {
          const el = panel.querySelector(sel);
          if (el) el.textContent = value || '—';
        };
        set('[data-fm-p-title]', card.dataset.fmTitle);
        set('[data-fm-p-price]', card.dataset.fmPrice);
        set('[data-fm-p-vendor]', card.dataset.fmVendor);
        set('[data-fm-p-desc]', card.dataset.fmDesc);
        // 自定义 metafield 行：无值自动隐藏该行
        for (let i = 1; i <= 4; i++) {
          const row = panel.querySelector('[data-fm-p-c' + i + '-row]');
          if (!row) continue;
          const val = card.dataset['fmC' + i];
          const lab = card.dataset['fmC' + i + 'Label'];
          const labEl = row.querySelector('[data-fm-p-c' + i + '-label]');
          const valEl = row.querySelector('[data-fm-p-c' + i + ']');
          if (labEl && lab) labEl.textContent = lab;
          if (valEl) valEl.textContent = val || '—';
          row.hidden = !val;
        }
        const compareRow = panel.querySelector('[data-fm-p-compare-row]');
        if (compareRow) {
          const hasCompare = !!card.dataset.fmCompare;
          compareRow.hidden = !hasCompare;
          if (hasCompare) set('[data-fm-p-compare]', card.dataset.fmCompare);
        }
        const link = panel.querySelector('[data-fm-p-link]');
        if (link && card.dataset.fmUrl) link.setAttribute('href', card.dataset.fmUrl);
        resetVariantPreview();
        buildVariantThumbs(card);
        syncAddButton(card.dataset.fmVdefault || '', card.dataset.fmVdefaultAvailable !== 'false');
      }

      // 面板变体缩略图：按选中卡的逐变体数据建按钮，点击切左侧背面卡图并同步价格/链接
      function buildVariantThumbs(card) {
        const wrap = panel ? panel.querySelector('[data-fm-p-variants]') : null;
        if (!wrap) return;
        const box = wrap.querySelector('[data-fm-p-thumbs]');
        if (box) box.replaceChildren();
        const count = parseInt(card.dataset.fmVcount || '0', 10) || 0;
        if (!box || count < 2) {
          wrap.hidden = true;
          return;
        }
        // 默认加购的是 selected_or_first_available_variant：把对应缩略图标为选中
        const defaultId = card.dataset.fmVdefault ? String(card.dataset.fmVdefault) : '';
        let defaultIndex = -1;
        for (let i = 0; i < count; i++) {
          const url = card.dataset['fmV' + i];
          if (!url) continue;
          const label = card.dataset['fmVt' + i] || 'Variant ' + (i + 1);
          const available = card.dataset['fmVa' + i] !== 'false';
          const isDefault = !!defaultId && String(card.dataset['fmVid' + i]) === defaultId;
          if (isDefault && defaultIndex < 0) defaultIndex = i;
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'fm-variant-thumb';
          btn.setAttribute('aria-pressed', isDefault ? 'true' : 'false');
          btn.setAttribute('data-option-available', available ? 'true' : 'false');
          btn.setAttribute('aria-label', available ? label : label + ' - ' + soldOutLabel);
          btn.setAttribute('title', label);
          const img = document.createElement('img');
          img.setAttribute('src', url);
          img.setAttribute('alt', label);
          img.setAttribute('loading', 'lazy');
          img.setAttribute('width', '88');
          img.setAttribute('height', '88');
          btn.appendChild(img);
          if (!available) {
            const tpl = root.querySelector('[data-fm-strike]');
            if (tpl && tpl.content) btn.appendChild(tpl.content.cloneNode(true));
          }
          btn.addEventListener('click', () => pickVariant(card, i));
          box.appendChild(btn);
        }
        if (defaultIndex >= 0) card._fmVariant = defaultIndex;
        wrap.hidden = !box.children.length;
      }

      // 变体切换时把该面板底部的标题条文字改成变体名
      function setPanelLabel(panelEl, text) {
        if (!panelEl || !text) return;
        const bar = panelEl.querySelector('[data-fm-ctitle]');
        if (bar) bar.textContent = text;
      }

      // ---- 加入购物车 ----
      function syncAddButton(variantId, available) {
        if (!addBtn) return;
        const lbl = addBtn.querySelector('.fm-add-to-cart__label');
        const hasVariant = !!variantId;
        const soldOut = hasVariant && !available;
        addBtn.dataset.variantId = variantId || '';
        addBtn.disabled = !hasVariant || soldOut;
        addBtn.classList.toggle('is-soldout', soldOut);
        addBtn.dataset.busy = 'false';
        addBtn.removeAttribute('aria-busy');
        addBtn.classList.remove('is-loading', 'is-added', 'is-error');
        if (lbl) lbl.textContent = soldOut ? soldOutLabel : addBtn.dataset.defaultLabel || lbl.textContent;
      }

      function dispatchCartUpdate(variantId, cart) {
        try {
          const evt = new Event('shopify:cart:lines-update', { bubbles: true, cancelable: true });
          evt.action = 'add';
          evt.context = 'product';
          evt.lines = [{ merchandiseId: variantId, quantity: 1 }];
          const total = cart && typeof cart.item_count === 'number' ? cart.item_count : 1;
          evt.promise = Promise.resolve({
            cart: { totalQuantity: total },
            detail: { itemCount: total, didError: false },
          });
          document.dispatchEvent(evt);
        } catch (e) {
          /* noop */
        }
      }

      function onAddToCart() {
        if (!addBtn) return;
        const variantId = addBtn.dataset.variantId;
        if (!variantId || addBtn.disabled || addBtn.dataset.busy === 'true') return;
        const routes = typeof Theme !== 'undefined' && Theme.routes ? Theme.routes : {};
        const addUrl = routes.cart_add_url || '/cart/add.js';
        const cartJsUrl = (routes.cart_url || '/cart') + '.js';
        const lbl = addBtn.querySelector('.fm-add-to-cart__label');
        const defaultLabel = addBtn.dataset.defaultLabel || (lbl ? lbl.textContent : '');
        addBtn.dataset.busy = 'true';
        addBtn.setAttribute('aria-busy', 'true');
        addBtn.classList.remove('is-added', 'is-error');
        addBtn.classList.add('is-loading');
        fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
        })
          .then((res) =>
            res.json().then((data) => {
              if (!res.ok) throw data;
              return data;
            })
          )
          .then(() => fetch(cartJsUrl, { headers: { Accept: 'application/json' } }))
          .then((res) => res.json())
          .then((cart) => {
            addBtn.classList.remove('is-loading');
            addBtn.classList.add('is-added');
            addBtn.removeAttribute('aria-busy');
            if (lbl) lbl.textContent = addedLabel;
            dispatchCartUpdate(variantId, cart);
            setTimeout(() => {
              addBtn.classList.remove('is-added');
              if (lbl) lbl.textContent = defaultLabel;
              addBtn.dataset.busy = 'false';
            }, 1500);
          })
          .catch(() => {
            addBtn.classList.remove('is-loading');
            addBtn.classList.add('is-error');
            addBtn.removeAttribute('aria-busy');
            if (lbl) lbl.textContent = addErrorLabel;
            setTimeout(() => {
              addBtn.classList.remove('is-error');
              if (lbl) lbl.textContent = defaultLabel;
              addBtn.dataset.busy = 'false';
            }, 1800);
          });
      }

      // ---- 变体牌堆：N 张同构卡循环传送带 ----
      function deckOffset(i) {
        const d = i * 12;
        return -d + 'px ' + d + 'px';
      }

      function deckSetImage(el, url, label) {
        if (!el) return;
        el.classList.remove('fm-deck-empty');
        const img = el.querySelector('[data-fm-deck-img]');
        if (img && url) {
          img.setAttribute('src', url);
          img.setAttribute('alt', label || '');
          img.hidden = false;
        }
        const bar = el.querySelector('[data-fm-ctitle]');
        if (bar) bar.textContent = label || '';
      }

      function deckClear(el) {
        if (!el) return;
        el.classList.add('fm-deck-empty');
        const img = el.querySelector('[data-fm-deck-img]');
        if (img) {
          img.hidden = true;
          img.removeAttribute('src');
          img.setAttribute('alt', '');
        }
        const bar = el.querySelector('[data-fm-ctitle]');
        if (bar) bar.textContent = '';
      }

      function setupDeck(card) {
        const arr = Array.from(card.querySelectorAll('[data-fm-deck-card]'));
        if (arr.length < 2) return;
        card._fmDeckCards = arr;
        arr.forEach((el, i) => {
          el.style.transitionDelay = '';
          el.style.translate = deckOffset(0);
          el.style.opacity = '';
          el.style.zIndex = String(arr.length - i);
          el.classList.toggle('fm-deck-top', i === 0);
          deckClear(el);
        });
        // 顶牌用翻面卡当前可见图播种
        const overlay = card.querySelector('.fm-panel--back [data-fm-vpreview]');
        const base = card.querySelector('.fm-panel--back .fm-face-img:not([data-fm-vpreview])');
        let seedUrl = '';
        if (overlay && !overlay.hidden && overlay.getAttribute('src')) seedUrl = overlay.getAttribute('src');
        else if (base) seedUrl = base.currentSrc || base.getAttribute('src') || '';
        deckSetImage(arr[0], seedUrl, card.dataset.fmVdefaultTitle || card.dataset.fmTitle || '');
        deckActive = true;
        card.classList.remove('fm-deck-on');
        if (card._fmDeckReadyTimer) clearTimeout(card._fmDeckReadyTimer);
        card._fmDeckReadyTimer = setTimeout(() => {
          card._fmDeckReadyTimer = null;
          revealDeck(card);
        }, 730);
      }

      // 入场：顶牌瞬时就位（与翻面卡连续），其余卡错峰展开淡入
      function revealDeck(card) {
        const arr = card._fmDeckCards;
        if (!arr) return;
        card.classList.add('fm-deck-on');
        arr.forEach((el, i) => {
          if (i === 0) {
            el.style.transition = 'none';
            el.style.opacity = '1';
            el.style.translate = deckOffset(0);
            void el.offsetWidth;
            el.style.transition = '';
          } else {
            el.style.transitionDelay = i * 55 + 'ms';
            el.style.translate = deckOffset(i);
          }
        });
      }

      function teardownDeck(card) {
        if (card._fmDeckReadyTimer) {
          clearTimeout(card._fmDeckReadyTimer);
          card._fmDeckReadyTimer = null;
        }
        if (card._fmDeckTimer) {
          clearTimeout(card._fmDeckTimer);
          card._fmDeckTimer = null;
        }
        card.classList.remove('fm-deck-on');
        const arr = card._fmDeckCards || [];
        arr.forEach((el) => {
          el.style.translate = '';
          el.style.opacity = '';
          el.style.zIndex = '';
          el.style.transitionDelay = '';
          el.classList.remove('fm-deck-top');
          el.classList.add('fm-deck-empty');
        });
        card._fmDeckCards = null;
        card._fmDeckTop = null;
        deckActive = false;
        const flip = card.querySelector('.fm-flip');
        if (flip) {
          flip.style.translate = '';
          flip.style.opacity = '';
          flip.style.zIndex = '';
          flip.classList.remove('fm-deck-empty');
        }
      }

      function playDeck(card, url, label) {
        const arr = card._fmDeckCards;
        if (!arr || arr.length < 2) return;
        if (card._fmDeckReadyTimer) {
          clearTimeout(card._fmDeckReadyTimer);
          card._fmDeckReadyTimer = null;
          revealDeck(card);
        }
        arr.forEach((el) => {
          el.style.transitionDelay = '';
        });
        const top = arr[0];
        const second = arr[1];
        deckSetImage(second, url, label);
        top.style.zIndex = '10';
        second.style.zIndex = '9';
        top.style.translate = '-140% 0px';
        top.style.opacity = '0';
        for (let i = 1; i < arr.length; i++) {
          arr[i].style.translate = deckOffset(i - 1);
          if (i > 1) arr[i].style.zIndex = String(arr.length - (i - 1));
        }
        card._fmDeckTop = second;
        card._fmSpinning = true;
        if (card._fmDeckTimer) clearTimeout(card._fmDeckTimer);
        card._fmDeckTimer = setTimeout(() => {
          card._fmDeckTimer = null;
          card._fmSpinning = false;
          deckClear(top);
          top.style.transition = 'none';
          top.style.translate = deckOffset(arr.length - 1);
          top.style.opacity = '0';
          void top.offsetWidth;
          top.style.transition = '';
          top.style.opacity = '';
          top.classList.remove('fm-deck-top');
          second.classList.add('fm-deck-top');
          arr.push(arr.shift());
          card._fmDeckTop = second;
          arr.forEach((el, i) => {
            el.style.zIndex = String(arr.length - i);
          });
        }, 560);
      }

      function pickVariant(card, i) {
        if (card._fmSpinning) return;
        if (card._fmVariant === i) return;
        card._fmVariant = i;
        const thumbs = panel ? panel.querySelectorAll('[data-fm-p-thumbs] .fm-variant-thumb') : [];
        thumbs.forEach((b, k) => b.setAttribute('aria-pressed', k === i ? 'true' : 'false'));
        const url = card.dataset['fmV' + i];
        if (panel) {
          const priceEl = panel.querySelector('[data-fm-p-price]');
          if (priceEl && card.dataset['fmVp' + i]) priceEl.textContent = card.dataset['fmVp' + i];
          const compareRow = panel.querySelector('[data-fm-p-compare-row]');
          if (compareRow) {
            const hasCompare = !!card.dataset['fmVc' + i];
            compareRow.hidden = !hasCompare;
            if (hasCompare) {
              const compareEl = panel.querySelector('[data-fm-p-compare]');
              if (compareEl) compareEl.textContent = card.dataset['fmVc' + i];
            }
          }
          const link = panel.querySelector('[data-fm-p-link]');
          if (link && card.dataset.fmUrl && card.dataset['fmVid' + i]) {
            link.setAttribute('href', card.dataset.fmUrl.split('?')[0] + '?variant=' + card.dataset['fmVid' + i]);
          }
        }
        if (root.dataset.fmMode === 'detail') {
          evalStacked();
          requestAnimationFrame(evalStacked);
        }
        const label = card.dataset['fmVt' + i] || card.dataset.fmTitle || '';
        syncAddButton(
          card.dataset['fmVid' + i] || card.dataset.fmVdefault || '',
          card.dataset['fmVa' + i] !== 'false'
        );
        if (card._fmDeckCards) {
          playDeck(card, url, label);
          return;
        }
        const setFace = (face, value) => {
          if (!face || !value) return;
          face.setAttribute('src', value);
          face.setAttribute('alt', label);
          face.hidden = false;
        };
        const flipEl = card.querySelector('.fm-flip');
        if (!flipEl || !url || reducedMotion()) {
          const backPanel = card.querySelector('.fm-panel--back');
          setFace(backPanel ? backPanel.querySelector('[data-fm-vpreview]') : null, url);
          setPanelLabel(backPanel, label);
          return;
        }
        // 整卡双面翻转：始终同向 +180°，先把即将翻出来（当前背面朝内）的那面换成新变体，再翻过去，中间不露原图
        const current = card._fmFlipDeg || 180;
        const target = current + 180;
        const targetPanel =
          target % 360 === 0 ? card.querySelector('.fm-panel--front') : card.querySelector('.fm-panel--back');
        setFace(targetPanel ? targetPanel.querySelector('[data-fm-vpreview]') : null, url);
        setPanelLabel(targetPanel, label);
        card._fmFlipDeg = target;
        card._fmSpinning = true;
        flipEl.style.setProperty('--fm-flip', target + 'deg');
        if (card._fmSpinTimer) clearTimeout(card._fmSpinTimer);
        card._fmSpinTimer = setTimeout(() => {
          card._fmSpinTimer = null;
          card._fmSpinning = false;
        }, 720);
      }

      // 清掉所有卡的变体预览（切卡/返回时复位，fillPanel 会重建缩略图与基准价格）
      function resetVariantPreview() {
        cards.forEach((c) => {
          if (c._fmSwapTimer) {
            clearTimeout(c._fmSwapTimer);
            c._fmSwapTimer = null;
          }
          if (c._fmSpinTimer) {
            clearTimeout(c._fmSpinTimer);
            c._fmSpinTimer = null;
          }
          delete c._fmSpinning;
          delete c._fmVariant;
          delete c._fmFlipDeg;
          if (c._fmDeckTimer) {
            clearTimeout(c._fmDeckTimer);
            c._fmDeckTimer = null;
          }
          teardownDeck(c);
          const flipEl = c.querySelector('.fm-flip');
          if (flipEl && flipEl.style.getPropertyValue('--fm-flip')) {
            flipEl.style.transition = 'none';
            flipEl.style.removeProperty('--fm-flip');
            void flipEl.offsetWidth;
            flipEl.style.transition = '';
          }
          c.querySelectorAll('[data-fm-vpreview]').forEach((preview) => {
            preview.hidden = true;
            preview.removeAttribute('src');
            preview.setAttribute('alt', '');
          });
          c.querySelectorAll('[data-fm-ctitle]').forEach((bar) => {
            const def = bar.getAttribute('data-fm-cdefault');
            if (def) bar.textContent = def;
          });
        });
        if (panel) {
          panel.querySelectorAll('[data-fm-p-thumbs] .fm-variant-thumb').forEach((b) => {
            b.setAttribute('aria-pressed', 'false');
          });
        }
      }

      function moveCardToSpot(card) {
        // 实测位移：悬浮面板(桌面)落画廊 30% 处；堆叠面板(桌面 fm-stacked)与移动端落 60% 处，主卡+左下牌堆整体更居中
        const gallery = root.querySelector('.fm-gallery');
        if (!gallery) return;
        // 测量时临时冻结过渡并把位移归零，量出“未位移”的真实中心。
        // 若直接清 --fm-move-x 再量，translate 过渡的中间值会污染测量，重算会把落点误算成 0。
        const prevTransition = card.style.transition;
        const prevMove = card.style.getPropertyValue('--fm-move-x');
        card.style.transition = 'none';
        card.style.setProperty('--fm-move-x', '0px');
        void card.offsetWidth;
        const gRect = gallery.getBoundingClientRect();
        const cRect = card.getBoundingClientRect();
        // 仍在冻结态还原测量前的内联状态，避免闪跳
        if (prevMove) card.style.setProperty('--fm-move-x', prevMove);
        else card.style.removeProperty('--fm-move-x');
        void card.offsetWidth;
        card.style.transition = prevTransition;
        if (gRect.width === 0 || cRect.width === 0) return;
        const isDesktop = window.matchMedia('(min-width: 750px)').matches;
        // 移动端卡片较大，落点统一居中到 0.5；桌面：悬浮面板 0.3、堆叠面板 0.6
        const ratio = !isDesktop ? 0.5 : root.classList.contains('fm-stacked') ? 0.6 : 0.3;
        const dx = gRect.left + gRect.width * ratio - (cRect.left + cRect.width / 2);
        card.style.setProperty('--fm-move-x', dx.toFixed(1) + 'px');
      }

      // FLIP：先在瞬时态下执行 mutate（改类/尺寸/落点），再用 translate+scale 把视觉拉回旧位置，
      // 随后清掉内联覆盖，卡片即从旧位置/旧尺寸平滑过渡到新位置/新尺寸（仅 transform，合成器驱动，无逐帧布局）。
      function flipTo(card, mutate) {
        if (reducedMotion()) {
          mutate();
          return;
        }
        const first = card.getBoundingClientRect();
        const prevTransition = card.style.transition;
        card.style.transition = 'none';
        mutate();
        void card.offsetWidth;
        const last = card.getBoundingClientRect();
        if (!first.width || !last.width || !first.height || !last.height) {
          card.style.transition = prevTransition;
          return;
        }
        const dx = first.left + first.width / 2 - (last.left + last.width / 2);
        const dy = first.top + first.height / 2 - (last.top + last.height / 2);
        const s = first.width / last.width;
        // 卡片自身的 translate 是「绝对覆盖」（含 --fm-move-x 等落点位移），
        // 所以 FLIP 偏移必须叠加当前基础 translate，视觉起点才与原位置重合。
        const base = (getComputedStyle(card).translate || '0px').split(' ');
        const baseX = parseFloat(base[0]) || 0;
        const baseY = parseFloat(base[1]) || 0;
        // 瞬时把视觉放回旧位置/旧尺寸
        card.style.scale = s.toFixed(4);
        card.style.translate = (dx + baseX).toFixed(1) + 'px ' + (dy + baseY).toFixed(1) + 'px';
        void card.offsetWidth;
        card.style.transition = prevTransition;
        requestAnimationFrame(() => {
          card.style.scale = '';
          card.style.translate = '';
        });
      }

      // 移动端标注视图：放大选中卡、保持正面、显示标注；不翻面、不开面板
      function enterInspect(card) {
        inspectCard = card;
        flipTo(card, () => {
          cards.forEach((c) => {
            c.classList.toggle('is-inspect', c === card);
            c.classList.toggle('is-dimmed', c !== card);
            c.classList.remove('is-selected');
          });
          root.dataset.fmMode = 'inspect';
          if (panel) panel.setAttribute('aria-hidden', 'true');
          if (inspectCta) inspectCta.hidden = false;
          moveCardToSpot(card);
        });
      }

      // 详情流程（原 select 主体）：翻面 + 落点 + 展开面板 + 建变体
      function enterDetail(card) {
        if (inspectCta) inspectCta.hidden = true;
        inspectCard = null;
        const apply = () => {
          cards.forEach((c) => {
            c.classList.toggle('is-selected', c === card);
            c.classList.toggle('is-dimmed', c !== card);
            c.classList.remove('is-inspect');
          });
          fillPanel(card);
          card._fmFlipDeg = 180;
          if ((parseInt(card.dataset.fmVcount || '0', 10) || 0) >= 2) setupDeck(card);
          root.dataset.fmMode = 'detail';
          if (panel) panel.setAttribute('aria-hidden', 'false');
          evalStacked();
        };
        if (useInspectView()) {
          // 移动端：从标注视图位置平滑过渡到详情落点（FLIP）；不再二次 evalStacked，避免打断过渡
          flipTo(card, apply);
        } else {
          apply();
          requestAnimationFrame(evalStacked);
        }
      }

      function select(card) {
        // 返回中的延迟摘堆叠先取消，防快速重选时误摘
        if (unstackTimer) {
          clearTimeout(unstackTimer);
          unstackTimer = null;
        }
        // 清掉可能残留的折叠退出内联样式
        if (panel) {
          panel.style.maxHeight = '';
          panel.style.marginTop = '';
          panel.style.paddingTop = '';
          panel.style.paddingBottom = '';
          panel.style.overflow = '';
        }
        freezeMotion();

        // 再点同一张卡 = 返回画廊（详情态与标注视图均适用）
        if (
          (root.dataset.fmMode === 'detail' && card.classList.contains('is-selected')) ||
          (root.dataset.fmMode === 'inspect' && card.classList.contains('is-inspect'))
        ) {
          backToGallery(true);
          return;
        }

        // 移动端两步：画廊中点卡先进入标注视图，再点「查看详情」才翻面进详情
        if (useInspectView()) {
          enterInspect(card);
          return;
        }

        enterDetail(card);
      }

      function backToGallery(focusCard) {
        const current = root.querySelector('[data-fm-book].is-selected, [data-fm-book].is-inspect');
        const apply = () => {
          cards.forEach((c) => {
            c.classList.remove('is-selected', 'is-dimmed', 'is-inspect');
            c.style.removeProperty('--fm-move-x');
          });
          inspectCard = null;
          if (inspectCta) inspectCta.hidden = true;
          root.dataset.fmMode = 'gallery';
          if (panel) panel.setAttribute('aria-hidden', 'true');
          if (focusCard && current) current.focus({ preventScroll: true });
          resetVariantPreview();
        };
        // 移动端：从详情/标注位置平滑缩回画廊原位置
        if (current && useInspectView()) {
          flipTo(current, apply);
        } else {
          apply();
        }
        // 堆叠态下折叠退出：面板收起+淡出，版面随之平滑收缩；播完同帧清内联+摘 class（不可见）
        if (unstackTimer) {
          clearTimeout(unstackTimer);
          unstackTimer = null;
        }
        freezeMotion();
        if (panel && root.classList.contains('fm-stacked') && window.matchMedia('(min-width: 750px)').matches) {
          panel.style.maxHeight = panel.scrollHeight + 'px';
          panel.style.overflow = 'hidden';
          void panel.offsetHeight;
          panel.style.maxHeight = '0px';
          panel.style.marginTop = '0px';
          panel.style.paddingTop = '0px';
          panel.style.paddingBottom = '0px';
          unstackTimer = setTimeout(() => {
            unstackTimer = null;
            if (panel) {
              panel.style.maxHeight = '';
              panel.style.marginTop = '';
              panel.style.paddingTop = '';
              panel.style.paddingBottom = '';
              panel.style.overflow = '';
            }
            root.classList.remove('fm-stacked');
          }, 650);
        }
      }

      // 进/退场过渡期冻结指针视差，避免 backdrop 重采样抖动；950ms 后恢复跟随
      function freezeMotion() {
        settling = true;
        if (settleTimer) clearTimeout(settleTimer);
        settleTimer = setTimeout(() => {
          settling = false;
          settleTimer = null;
        }, 1000);
      }

      // 内容大幅超高（超过 STACK_TOLERANCE）才放画廊底下；轻微溢出保留在右侧走内部滚动
      function evalStacked() {
        if (unstackTimer) return; // 折叠退出动画进行中，不抢摘
        if (!panel || root.dataset.fmMode !== 'detail') {
          root.classList.remove('fm-stacked');
          return;
        }
        root.classList.remove('fm-stacked');
        void panel.offsetHeight;
        const overflows = panel.scrollHeight - panel.clientHeight > STACK_TOLERANCE;
        root.classList.toggle('fm-stacked', overflows);
        // 落点比例随是否堆叠变化：统一在确定 stacked 后重算（含窗口 resize 场景）
        const selected = root.querySelector('[data-fm-book].is-selected');
        if (selected) moveCardToSpot(selected);
      }

      cards.forEach((card) => {
        card.addEventListener('click', () => select(card));
        card.addEventListener('pointerenter', () => {
          card.dataset.hovered = 'true';
        });
        card.addEventListener('pointerleave', () => {
          card.dataset.hovered = 'false';
        });
      });

      if (addBtn) addBtn.addEventListener('click', onAddToCart);

      if (backBtn) backBtn.addEventListener('click', () => backToGallery(true));

      if (inspectCta) {
        inspectCta.addEventListener('click', () => {
          const card = root.querySelector('[data-fm-book].is-inspect');
          if (card) enterDetail(card);
        });
      }

      root.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && (root.dataset.fmMode === 'detail' || root.dataset.fmMode === 'inspect')) {
          backToGallery(true);
        }
      });

      function onResize() {
        if (root.dataset.fmMode === 'detail') evalStacked();
      }
      window.addEventListener('resize', onResize);

      // 全局视差：指针位置写入根变量，卡片按各自 --fm-depth 换算（CSS 侧相乘）
      // 指针空闲 ~180ms 后停帧，避免常驻 rAF；root 矩形每帧只读一次
      function scheduleParallax() {
        parallaxActive = true;
        if (parallaxIdleTimer) clearTimeout(parallaxIdleTimer);
        parallaxIdleTimer = setTimeout(() => {
          parallaxActive = false;
          parallaxIdleTimer = null;
        }, 180);
        if (raf != null || reducedMotion() || !inView || settling) return;
        const tick = () => {
          raf = null;
          if (reducedMotion() || !inView || settling) return;
          const rect = root.getBoundingClientRect();
          if (rect.width !== 0 && rect.height !== 0) {
            const nx = (pointerX - rect.left) / rect.width - 0.5;
            const ny = (pointerY - rect.top) / rect.height - 0.5;
            root.style.setProperty('--fm-mx', (nx * 11).toFixed(2) + 'px');
            root.style.setProperty('--fm-my', (ny * 8).toFixed(2) + 'px');
          }
          if (parallaxActive && (root.dataset.fmMode === 'gallery' || deckActive)) {
            raf = requestAnimationFrame(tick);
          }
        };
        raf = requestAnimationFrame(tick);
      }

      if (
        parallaxOn &&
        window.matchMedia(FINE_POINTER).matches &&
        !reducedMotion() &&
        window.IntersectionObserver
      ) {
        observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              inView = entry.isIntersecting;
              if (!inView && raf != null) {
                cancelAnimationFrame(raf);
                raf = null;
              }
            });
          },
          { root: null, threshold: 0.01 }
        );
        observer.observe(root);
        root.addEventListener('pointermove', (e) => {
          pointerX = e.clientX;
          pointerY = e.clientY;
          scheduleParallax();
        });
      }

      // 卡片进场：滚动到该区块时，卡片由画廊中心散开到各自扇位 + 0->1 淡入
      const gallery = root.querySelector('.fm-gallery');
      let cardsIntroObserver = null;
      if (gallery && root.hasAttribute('data-fm-cards-intro')) {
        const clearIntroVars = () => {
          cards.forEach((c) => {
            c.style.removeProperty('--fm-card-center-offset');
            c.style.removeProperty('transition-delay');
          });
        };
        const revealCards = () => root.removeAttribute('data-fm-cards-intro');
        if (reducedMotion() || !window.IntersectionObserver || (window.Shopify && window.Shopify.designMode)) {
          revealCards();
          clearIntroVars();
        } else if (cards.length > 0) {
          // 测量每张卡相对画廊中心的水平偏移，先无过渡地收拢到中心
          cards.forEach((c) => c.style.setProperty('transition', 'none'));
          const grect = gallery.getBoundingClientRect();
          const gcenter = grect.left + grect.width / 2;
          const mid = (cards.length - 1) / 2;
          cards.forEach((c) => {
            const r = c.getBoundingClientRect();
            const ccenter = r.left + r.width / 2;
            c.style.setProperty('--fm-card-center-offset', (gcenter - ccenter).toFixed(1) + 'px');
          });
          cards.forEach((c) => {
            void c.offsetWidth;
          });
          cards.forEach((c) => c.style.removeProperty('transition'));
          // 由中间向外轻微错峰
          cards.forEach((c, i) => {
            c.style.setProperty('transition-delay', Math.round(Math.abs(i - mid) * 70) + 'ms');
          });
          cardsIntroObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                revealCards();
                if (cardsIntroObserver) {
                  cardsIntroObserver.disconnect();
                  cardsIntroObserver = null;
                }
                setTimeout(clearIntroVars, 1200);
              });
            },
            { root: null, threshold: 0.01, rootMargin: '0px 0px -2% 0px' }
          );
          cardsIntroObserver.observe(gallery);
        } else {
          revealCards();
        }
      }

      // 顶部巨字进场：滚动到该区块（巨字进入视口）才从上向下浮入 + 0->1 淡入
      const heroWord = root.querySelector('.fm-hero-word[data-fm-hero-intro]');
      let heroObserver = null;
      if (heroWord && !heroWord.hasAttribute('data-fm-hero-in')) {
        const revealHero = () => heroWord.setAttribute('data-fm-hero-in', '');
        if (reducedMotion() || !window.IntersectionObserver) {
          revealHero();
        } else {
          heroObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                revealHero();
                heroObserver.disconnect();
                heroObserver = null;
              });
            },
            { root: null, threshold: 0.01, rootMargin: '0px 0px -2% 0px' }
          );
          heroObserver.observe(heroWord);
        }
      }

      root._fmTeardown = () => {
        if (raf != null) cancelAnimationFrame(raf);
        if (parallaxIdleTimer) clearTimeout(parallaxIdleTimer);
        parallaxActive = false;
        if (observer) observer.disconnect();
        if (cardsIntroObserver) {
          cardsIntroObserver.disconnect();
          cardsIntroObserver = null;
        }
        if (heroObserver) {
          heroObserver.disconnect();
          heroObserver = null;
        }
        if (unstackTimer) clearTimeout(unstackTimer);
        if (settleTimer) clearTimeout(settleTimer);
        window.removeEventListener('resize', onResize);
        delete root._fmTeardown;
      };
    }

    function teardownRoot(root) {
      if (root._fmTeardown) root._fmTeardown();
      delete root.dataset.fmInit;
    }

    function initAll(scope) {
      (scope || document).querySelectorAll(SELECTOR).forEach(setupRoot);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(document));
    } else {
      initAll(document);
    }
    document.addEventListener('shopify:section:load', (e) => initAll(e.target));
    document.addEventListener('shopify:section:unload', (e) => {
      const root = e.target && e.target.querySelector ? e.target.querySelector(SELECTOR) : null;
      if (root) teardownRoot(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wanedc-hero-scroll"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SELECTOR = '.wanedc-hero-scroll';
    var sections = document.querySelectorAll(SELECTOR);
    if (!sections.length) return;

    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isLowPower = (navigator.hardwareConcurrency && navigator.hardwareConcurrency <= 2) || (navigator.deviceMemory && navigator.deviceMemory <= 2);

    function pad2(n) {
      return String(n).padStart(2, '0');
    }

    function clamp(v, min, max) {
      return Math.min(max, Math.max(min, v));
    }

    (function setFixedVH() {
      var vh = window.innerHeight;
      document.documentElement.style.setProperty('--wanedc-vh', vh + 'px');
    })();

    sections.forEach(function (section) {
      var baseUrl = section.dataset.baseUrl;
      var vParam = section.dataset.vParam || '';
      var ext = section.dataset.ext || '.webp';
      var frameCount = parseInt(section.dataset.frameCount, 10) || 100;
      var fps = parseInt(section.dataset.fps, 10) || 25;
      var canvas = section.querySelector('.wanedc-hero-scroll__canvas');
      var fallbackImg = section.querySelector('.wanedc-hero-scroll__fallback');
      var finalImg = section.querySelector('.wanedc-hero-scroll__final');
      var content = section.querySelector('.wanedc-hero-scroll__content');
      var debugMode = section.dataset.debugMode === 'true';
      function debugLog(msg, data) {
        if (!debugMode) return;
        console.log('[wanedc-hero-scroll]', msg, data || '');
      }
      debugLog('init', { baseUrl: baseUrl, frameCount: frameCount, fps: fps, hasFinal: !!finalImg, vParam: vParam, ext: ext });
      if (!canvas || !baseUrl) {
        debugLog('ERROR no canvas or baseUrl', { canvas: !!canvas, baseUrl: baseUrl });
        return;
      }
      var ctx = canvas.getContext('2d', { alpha: false });
      var frames = new Array(frameCount);
      var loaded = 0;
      var currentIdx = 0;
      var hasPlayed = false;

      function buildUrl(i) {
        return baseUrl + pad2(i + 1) + ext + vParam;
      }

      var initialVH = window.innerHeight;
      var initialVW = window.innerWidth;
      function resizeCanvas() {
        var currentVW = window.innerWidth;
        if (Math.abs(currentVW - initialVW) < 5 && Math.abs(window.innerHeight - initialVH) < 100) {
          return;
        }
        initialVW = currentVW;
        initialVH = window.innerHeight;
        document.documentElement.style.setProperty('--wanedc-vh', initialVH + 'px');
        var dpr = Math.min(window.devicePixelRatio || 1, 2);
        var rect = canvas.getBoundingClientRect();
        canvas.width = Math.round(rect.width * dpr);
        canvas.height = Math.round(rect.height * dpr);
        if (frames[currentIdx]) drawFrame(frames[currentIdx]);
        if (hasPlayed && finalImg) {
          canvas.style.opacity = '0';
          finalImg.style.opacity = '1';
        }
      }

      function drawCover(img) {
        if (!ctx || !img) return;
        var cw = canvas.width;
        var ch = canvas.height;
        var iw = img.naturalWidth || img.width || 1280;
        var ih = img.naturalHeight || img.height || 720;
        var cr = cw / ch;
        var ir = iw / ih;
        var sx = 0, sy = 0, sw = iw, sh = ih;
        if (ir > cr) {
          sw = sh * cr;
          sx = (iw - sw) / 2;
        } else {
          sh = sw / cr;
          sy = (ih - sh) / 2;
        }
        ctx.clearRect(0, 0, cw, ch);
        ctx.drawImage(img, sx, sy, sw, sh, 0, 0, cw, ch);
      }

      function drawFrame(img) {
        if (!img) {
          debugLog('drawFrame skip null img', { currentIdx: currentIdx });
          return;
        }
        drawCover(img);
        if (fallbackImg) fallbackImg.style.display = 'none';
        canvas.style.display = 'block';
      }

      function loadImage(src) {
        return new Promise(function (resolve) {
          var img = new Image();
          img.decoding = 'async';
          if ('fetchPriority' in img) img.fetchPriority = 'high';
          img.onload = function () {
            if (img.decode) {
              img.decode().then(function () { resolve(img); }).catch(function () { resolve(img); });
            } else {
              resolve(img);
            }
          };
          img.onerror = function () { resolve(null); };
          img.src = src;
        });
      }

      async function preloadRange(start, end, concurrency) {
        debugLog('preloadRange start', { start: start, end: end, concurrency: concurrency });
        var queue = [];
        for (var i = start; i < end; i++) queue.push(i);
        var workers = [];
        var pool = Math.min(concurrency || 6, queue.length);
        for (var w = 0; w < pool; w++) {
          workers.push(
            (async function () {
              while (queue.length) {
                var idx = queue.shift();
                if (frames[idx]) continue;
                var img = await loadImage(buildUrl(idx));
                if (img) {
                  frames[idx] = img;
                  loaded++;
                } else {
                  debugLog('preload failed', { idx: idx, url: buildUrl(idx) });
                }
                await new Promise(function (r) { setTimeout(r, 0); });
              }
            })()
          );
        }
        await Promise.all(workers);
        debugLog('preloadRange done', { start: start, end: end, loaded: loaded, total: frameCount });
      }

      async function ensureFinalImageReady() {
        if (!finalImg) return;
        try {
          if (finalImg.complete && finalImg.naturalWidth) {
            if (finalImg.decode) await finalImg.decode().catch(function(){});
            return;
          }
          await new Promise(function (resolve) {
            finalImg.onload = function(){ resolve(); };
            finalImg.onerror = function(){ resolve(); };
            if (finalImg.decode) finalImg.decode().then(resolve).catch(resolve);
          });
        } catch(e) {}
      }

      async function autoplayAll() {
        debugLog('autoplayAll start', { frameCount: frameCount, fps: fps, hasFinal: !!finalImg });
        if (prefersReduced || isLowPower) {
          debugLog('autoplay skipped reduced/lowPower', { prefersReduced: prefersReduced, isLowPower: isLowPower });
          if (finalImg) {
            finalImg.style.opacity = '1';
            canvas.style.display = 'none';
            canvas.style.opacity = '0';
          } else if (frames[0]) {
            drawFrame(frames[0]);
          }
          hasPlayed = true;
          return;
        }
        if (finalImg) {
          await ensureFinalImageReady();
          finalImg.style.opacity = '0';
          canvas.style.opacity = '1';
        }
        var fadeStart = frameCount - fps;
        if (fadeStart < 0) fadeStart = 0;
        var fadeLen = frameCount - fadeStart;
        if (fadeLen <= 1) fadeLen = 1;
        for (var i = 0; i < frameCount; i++) {
          if (!frames[i]) {
            debugLog('autoplay skip missing frame', { i: i });
            continue;
          }
          currentIdx = i;
          drawFrame(frames[i]);
          if (finalImg && i >= fadeStart) {
            var progress = (i - fadeStart) / (fadeLen - 1);
            progress = clamp(progress, 0, 1);
            canvas.style.opacity = String(1 - progress);
            finalImg.style.opacity = String(progress);
            debugLog('fade', { i: i, progress: progress.toFixed(2) });
          } else if (finalImg) {
            canvas.style.opacity = '1';
            finalImg.style.opacity = '0';
          }
          await new Promise(function (r) { setTimeout(r, 1000 / fps); });
        }
        debugLog('autoplayAll done', { hasPlayed: true });
        hasPlayed = true;
        if (finalImg) {
          canvas.style.opacity = '0';
          finalImg.style.opacity = '1';
          setTimeout(function(){
            canvas.style.display = 'none';
            if (fallbackImg) fallbackImg.style.display = 'none';
          }, 250);
        } else {
          canvas.style.opacity = '1';
        }
      }

      window.addEventListener('resize', resizeCanvas, { passive: true });
      document.addEventListener('shopify:section:load', function (e) {
        if (e.target.contains(section)) {
          resizeCanvas();
        }
      });

      resizeCanvas();
      preloadRange(0, Math.min(frameCount, 3), 3).then(function () {
        if (frames[0]) drawFrame(frames[0]);
        if (finalImg) finalImg.style.opacity = '0';
        return preloadRange(0, frameCount, 6);
      }).then(function () {
        autoplayAll();
      });

      var ro = new ResizeObserver(function () { resizeCanvas(); });
      ro.observe(canvas);

      if (prefersReduced) {
        if (finalImg) {
          canvas.style.display = 'none';
          finalImg.style.display = 'block';
          finalImg.style.opacity = '1';
        } else {
          canvas.style.display = 'none';
          if (fallbackImg) fallbackImg.style.display = 'block';
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wanedc-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const heroes = document.querySelectorAll('.hero[data-hero-intro="true"]');
    heroes.forEach((hero) => {
      const imgs = [...hero.querySelectorAll('.hero__media-grid img.hero__media')];
      if (imgs.length === 0) {
        hero.classList.add('hero-intro-loaded');
        return;
      }
      let pending = imgs.length;
      const onDone = () => {
        pending -= 1;
        if (pending === 0) hero.classList.add('hero-intro-loaded');
      };
      imgs.forEach((img) => {
        if (img.complete && img.naturalWidth > 0) {
          onDone();
          return;
        }
        img.addEventListener('load', onDone, { once: true });
        img.addEventListener('error', onDone, { once: true });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
